import { Component, input } from '@angular/core';

/**
 * Cabeçalho de página: bloco com fundo primary, ícone grande, título e descrição.
 * Ações (botões, filtros) são projetadas via `<... actions>`.
 * O estilo vive em styles.scss (classes .page-header*), não há scss próprio.
 */
@Component({
  selector: 'app-page-header',
  imports: [],
  templateUrl: './page-header.html',
})
export class PageHeader {
  readonly icon = input('fe-file');
  readonly pretitle = input('');
  readonly title = input.required<string>();
  readonly description = input('');
}
